// Public Power BI identifiers used to build the reportEmbed URL.
// These must match POWERBI_REPORT_ID and POWERBI_WORKSPACE_ID on the server.
// The Entra client secret stays on the server.
export const POWERBI_REPORT_ID =
  process.env.REACT_APP_POWERBI_REPORT_ID || '18af7c9d-8103-4f4f-917c-e6cc6499a305';

export const POWERBI_WORKSPACE_ID =
  process.env.REACT_APP_POWERBI_WORKSPACE_ID || 'ed7cb021-9a77-4676-a340-ae6f5ef229bc';
